<m-maskedfield class="m-postalcodefield"
               v-bind="bindData"
               v-on="$listeners"
               :id="id"
               :mask-options="maskOptions">
</m-maskedfield>
